import React, { useEffect } from "react";

//Styles
import Styles from "./marketing-redirections.module.scss";

// Components
import Spinner from "components/reuseables/Spinner";

const PORTAL_URL = process.env.NEXT_PUBLIC_PORTAL_URL;

const MarketingProfileRedirection = ({
  dataProfile,
}) => {

  useEffect(() => {
    if (dataProfile?.username) {
      window.location.href = `${PORTAL_URL}/marketing/${dataProfile.username}`;
    }
  }, [dataProfile])
  
  return (
    <div className={Styles["spinner-wrapper"]}>
      <Spinner />
    </div>
  );
};

export default MarketingProfileRedirection;
